import { NavArrowLeftIcon } from '@sketchnote/icons';
import cn from 'classnames';
import * as React from 'react';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { Swiper } from 'swiper/react';

SwiperCore.use([Navigation, Pagination]);

const { Fragment } = React;

export const CatalogCarousel = ({
  children,
  iconColor = 'text-white',
}: {
  children: JSX.Element | JSX.Element[];
  iconColor?: string;
}): JSX.Element => {
  return (
    <Fragment>
      <button
        className={cn({ 'absolute banner-slider-prev': true, [iconColor]: !!iconColor })}
        style={{ transform: 'rotate(0deg)', left: '-6.3rem', top: '13rem' }}
      >
        <NavArrowLeftIcon />
      </button>
      <Swiper
        slidesPerView={2}
        spaceBetween={15}
        navigation={{
          nextEl: '.banner-slider-next',
          prevEl: '.banner-slider-prev',
        }}
        pagination={{
          el: '.swiper-pagination',
          clickable: true,
        }}
      >
        {children}
      </Swiper>
      <button
        className={cn({ 'absolute banner-slider-next': true, [iconColor]: !!iconColor })}
        style={{ transform: 'rotate(180deg)', right: '-6.3rem', top: '13rem' }}
      >
        <NavArrowLeftIcon />
      </button>
      <div className={cn({ 'swiper-pagination catalogue-carousel-dot': true })} />
    </Fragment>
  );
};
